import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import i18n, { setAppLocale, SUPPORTED_LOCALES, DEFAULT_LOCALE } from "@/i18n";

const LocaleContext = createContext(null);

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(i18n.language || DEFAULT_LOCALE);

  useEffect(() => {
    const onChanged = (lng) => setLocaleState(lng);
    i18n.on("languageChanged", onChanged);
    return () => i18n.off("languageChanged", onChanged);
  }, []);

  useEffect(() => {
    try {
      document.documentElement.lang = locale;
    } catch {
      /* noop */
    }
  }, [locale]);

  const setLocale = useCallback((next) => {
    if (!SUPPORTED_LOCALES.includes(next)) return;
    setAppLocale(next);
  }, []);

  return (
    <LocaleContext.Provider value={{ locale, setLocale, supported: SUPPORTED_LOCALES }}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error("useLocale must be used inside LocaleProvider");
  return ctx;
}

export function pickLocalized(obj, locale, fallback = "") {
  if (!obj) return fallback;
  if (typeof obj === "string") return obj;
  return obj[locale] || obj.hr || obj.en || fallback;
}
